import { atom } from "recoil";

export const jettonActionsState = atom({
  key: "jettonActions",
  default: false,
});
